import React, { useRef } from "react";
import PageHeading from "../../components/PageHeading";
import * as Yup from "yup";
import { imageFormat, imageSize } from "../../utils/functions";
import { useNavigate } from "react-router-dom";
import { useQueryClient } from "react-query";
import { useDispatch } from "react-redux";
import FormikContainer from "../../components/Formik/FormikContainer";
import { Form } from "formik";
import imageManagerServices from "../../services/imageManager";

import FieldContainer from "../../components/Formik/FieldContainer";
import { Spinner } from "@chakra-ui/react";
import DImage from "../../components/DImage";
import DButton from "../../components/DButton";
import DCard from "../../components/DCard";
import toast from "react-hot-toast";

const initialValues = {
  img: "",

};

const validationSchema = Yup.object().shape({

  img: Yup.mixed()
    .test("image-format", "يرجى تحميل صورة", (value) => {
      return value ? imageFormat.includes(value.type.split("/")[1]) : false;
    })
    .test("img-size", "حجم الصورة لايجب ان يتجاوز 5mb", (value) => {
      return value ? imageSize >= value.size : false;
    }),
});
const AddImage = ({ title }) => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const dispatch = useDispatch();
  const onSubmit = (values, { setSubmitting }) => {
    const formData = new FormData();
    formData.append("img", values.img);

    imageManagerServices
    .addImage(formData, values.category)
    .then(res => {
        toast.success("تم اضافة الصورة ");
        queryClient.refetchQueries("getAllImages");
        setTimeout(() => {
            navigate("/images-manger", { replace: true });
        }, 1500);
    })
    .catch(err => {
        console.log(err);
        toast.error("فشلت اضافة المنتج");
        setSubmitting(false);
    });


  };

  const fileRef = useRef();

  const setImageHandler = (value) => {
    if (value?.type) {
      return URL.createObjectURL(value);
    }
    return value;
  };
  const deleteImageHandler = (setFieldValue) => {
    fileRef.current.value = "";
    setFieldValue("img", "");
  };
  return (
    <div>
      <PageHeading>{title}</PageHeading>
      <DCard className="min-h-[300px]">
        <FormikContainer
          onSubmit={onSubmit}
          initialValues={initialValues}
          validationSchema={validationSchema}
        >
          {({ values, setFieldValue, isSubmitting }) => {
            return (
              <Form>
                <div className="md:flex md:flex-col md:items-center">
                  <div className="mb-4 text-center">
                    <FieldContainer
                      fileRef={fileRef}
                      name="img"
                      type="file"
                      accept="image/*"
                      id="img"
                      hidden
                    />
                    {values.img && (
                      <>
                        <div className="mb-4 relative sm:w-[250px] h-[250px] border border-light-color rounded-sm">
                          <DImage
                            className="w-full h-full object-contain"
                            src={setImageHandler(values.img)}
                            alt={"product-image"}
                            load={true}
                          />
                        </div>
                        <DButton
                          onClick={() => deleteImageHandler(setFieldValue)}
                          className="text-white"
                          bgColor="danger"
                        >
                          حذف الصورة
                        </DButton>
                      </>
                    )}
                    <DButton
                      bgColor="secondry"
                      onClick={() => fileRef.current?.click()}
                    >
                      تحميل صورة
                    </DButton>
                    <div className="blokc">
                      {/* <ErrorMessage name="img" component={ErrorMsg} /> */}
                    </div>
                  </div>
                </div>
                <DButton
                  disabled={isSubmitting}
                  type="submit"
                  className="w-full mx-auto rounded-lg flex items-center justify-center md:max-w-[150px] text-white"
                >
                  {isSubmitting ? <Spinner /> : "تحميل "}
                </DButton>
              </Form>
            );
          }}
        </FormikContainer>
      </DCard>
    </div>
  );
};

export default AddImage;
